import {
    Divider,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
  } from "@chakra-ui/react";
  import React, {  useState } from "react";
  import Form from "react-bootstrap/Form";
  import Col from "react-bootstrap/Col";
  import Row from "react-bootstrap/Row";
  import { InputGroup, Tab, Tabs } from "react-bootstrap";
  import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import moment from "moment";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
  

  const DataRow = ({ label, value, type,currency }) => {
    return (
      <>
          <Form.Label>{label}</Form.Label>
      {type === 'Amount' 
      ?
      <InputGroup>
        <InputGroup.Text style={{height:'2rem', border:0, background:'lightGray'}}><span className="rupee-symbol">{currencySymbolByCode(currency || "INR")}</span> </InputGroup.Text>
        <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? formatAmountIndianRupees(value) : " "}
        disabled
      />
      </InputGroup>
      :
      <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? value : " "}
        disabled
      />
      }
      </>
    );
  };
  
  const InvoiceTdsInfoModel = ({ openInfoModal, closeInfoModal, selectedItem, role }) => {
    const [activeTab, setActiveTab] = useState("information");
    return (
      <div>
        <Modal
          isOpen={openInfoModal}
          onClose={closeInfoModal}
          size="xl"
          className="modal-main"
        >
          <ModalOverlay />
          <ModalContent  
          top="0" // Position it at the top
           margin="0 auto" // Center it horizontally
           bottom="0"
           className="info-model">
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header mt-0">
                <span>TDS Information</span>
              </ModalHeader>
              <ModalCloseButton />
            </div>
            <ModalBody>
              <Form className="addForm">
                <Tabs
                  id="justify-tab-example1"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className=""
                  justify
                >
                  <Tab
                    eventKey="information"
                    title="Information"
                    className="main-tab-item"
                  >
                    <div className="card">
                      <h5 className="heading-h5">Invoice Details</h5>
  
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Invoice Number"
                            value={InvoiceNumberFormate(selectedItem?.inId?.inNo)}
                          />
                        </Col>
                        <Col>
                          <DataRow label="Invoice Date" value={
                              selectedItem?.inId?.inDt
                                ? moment(selectedItem?.inId?.inDt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            } />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Invoice Currency"
                            value={(selectedItem?.inId?.inCr)}
                          />
                        </Col>
                        <Col>
                          <DataRow label="Due Date" value={
                              selectedItem?.inId?.duDt
                                ? moment(selectedItem?.inId?.duDt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            } />
                        </Col>
                        </Row>
                      <Divider
                      className="info-divider mt-3"
                      orientation="horizontal"
                    />
                    <h5 className="heading-h5">TDS Client Detail</h5>
                    
                      <Row className="info-row">
                      <Col>
                          <DataRow
                            label="Client Name"
                            value={selectedItem?.cId?.clName}
                          />
                        </Col>
                        <Col>
                          
                        </Col>
                       
                      </Row>
                      <Divider
                      className="info-divider mt-3"
                      orientation="horizontal"
                    />
                    <h5 className="heading-h5">TDS Amount Detail</h5>
                      <Row className="info-row">
                     <Col>
                     <DataRow
                            label="Base Amount"
                            value={Number(selectedItem?.bsAmt || 0)}
                            type='Amount'
                            currency={selectedItem?.inId?.inCr || "INR"}

                          />
                        </Col>
                        <Col></Col>
                     </Row>
                      <Row className="info-row">
                      <Col>
                          <DataRow
                            label="Percentage"
                            value={`${selectedItem?.prc} %` || 0}
                          />
                        </Col>
                      <Col>
                          <DataRow
                            label="TDS Amount"
                            value={selectedItem?.tdsAmt || 0}
                            type='Amount'
                            currency={selectedItem?.inId?.inCr || "INR"}
                          />
                        </Col>
                        
                    </Row>
                   
                    </div>
                  </Tab>
                 <Tab
                  eventKey=""
                  title=""
                  disabled
                  className="main-tab-item"
                 >
                 </Tab>
                </Tabs>
              </Form>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    );
  };
  
  export default InvoiceTdsInfoModel;
  